export const navLinks = [
  { id: "hot", label: "实时热榜" },
  { id: "topics", label: "话题板块" },
  { id: "treehole", label: "深夜树洞" },
  { id: "play", label: "玩转瓜田" },
  { id: "faq", label: "常见问题" },
];

export const stats = [
  { value: "326 万+", label: "活跃瓜友" },
  { value: "180 万+", label: "累计发帖" },
  { value: "9 800+", label: "每日热帖" },
  { value: "24h", label: "全天候开放" },
];

export type HotItem = {
  rank: number;
  tag: string;
  tagType: "fire" | "new" | "top" | "normal";
  title: string;
  category: string;
  comments: string;
  likes: string;
  heat: string;
  snippet: string;
};

export const hotLatest: HotItem[] = [
  {
    rank: 1,
    tag: "爆",
    tagType: "fire",
    title: "某选秀综艺三公直拍流出，网友刷屏“这期封神”",
    category: "综艺现场",
    comments: "8.6k",
    likes: "4.2w",
    heat: "99.8 万热度",
    snippet: "舞台运镜和选曲都很有质感，评论区已经吵成一片，支持票断层领先。",
  },
  {
    rank: 2,
    tag: "热",
    tagType: "new",
    title: "顶流剧组夜戏路透：男女主同框，粉丝蹲后续蹲到凌晨",
    category: "剧组路透",
    comments: "6.1k",
    likes: "3.7w",
    heat: "76.4 万热度",
    snippet: "路人偶遇照传回站内，同框即热搜体质，今晚的瓜田又丰收了。",
  },
  {
    rank: 3,
    tag: "热",
    tagType: "top",
    title: "爆款短剧二搭实锤？原班人马晒同框花絮",
    category: "短剧观察",
    comments: "5.2k",
    likes: "2.9w",
    heat: "61.9 万热度",
    snippet: "售后营业拉满，剧粉直呼嗑到真的，评论区已开启全屏撒糖模式。",
  },
  {
    rank: 4,
    tag: "新",
    tagType: "normal",
    title: "主播直播口误引热议，弹幕玩梗玩出一整片“名场面”",
    category: "网红吃瓜",
    comments: "3.9k",
    likes: "2.1w",
    heat: "48.2 万热度",
    snippet: "一个口误被网友二创成系列梗，树洞里都有人点名下回再聊。",
  },
];

export const hotTrending: HotItem[] = [
  {
    rank: 1,
    tag: "沸",
    tagType: "fire",
    title: "年度盛典红毯造型盘点，谁的妆造杀疯了",
    category: "明星红毯",
    comments: "9.8k",
    likes: "5.6w",
    heat: "118 万热度",
    snippet: "各家造型师名单被扒了个遍，红毯名场面一帧帧封神，评论区前排全是高清生图。",
  },
  {
    rank: 2,
    tag: "热",
    tagType: "top",
    title: "剧组官博深夜晒花絮，片场趣事让老粉集体破防",
    category: "剧组日常",
    comments: "7.4k",
    likes: "4.1w",
    heat: "88.7 万热度",
    snippet: "一张图背后全是故事，老粉晒出考古证据，瓜田里的讨论深度直接拉满。",
  },
  {
    rank: 3,
    tag: "新",
    tagType: "new",
    title: "新人歌手出道舞台被指“紧张到忘词”，口碑两极",
    category: "乐坛热点",
    comments: "4.6k",
    likes: "2.3w",
    heat: "52.1 万热度",
    snippet: "有人心疼有人调侃，树洞和群聊双开麦，公说公有理就看你怎么站队。",
  },
  {
    rank: 4,
    tag: "热",
    tagType: "normal",
    title: "古偶剧组被曝服化道敷衍，妆造细节翻车全复盘",
    category: "服化道鉴瓜",
    comments: "5.8k",
    likes: "3.3w",
    heat: "69.5 万热度",
    snippet: "网友逐帧截图对比历代造型，把“不用心”写在了脸上，官方至今未回应。",
  },
];

export const hotHot: HotItem[] = [
  {
    rank: 1,
    tag: "爆",
    tagType: "fire",
    title: "现象级黑马剧大结局，弹幕哭成一片泪海",
    category: "影视结局",
    comments: "12k",
    likes: "7.8w",
    heat: "152 万热度",
    snippet: "最后一集信息量拉满，从微博吵到树洞，结局解读帖一晚上开了上百条讨论。",
  },
  {
    rank: 2,
    tag: "沸",
    tagType: "top",
    title: "老牌乐队重组官宣巡演，情怀粉当场泪目",
    category: "音乐巡演",
    comments: "8.9k",
    likes: "5.1w",
    heat: "97.3 万热度",
    snippet: "出道二十年的乐队官宣合体，站内即时开起“老歌点播”群聊，情怀浓度超标。",
  },
  {
    rank: 3,
    tag: "热",
    tagType: "new",
    title: "带货主播联动直播翻车？优惠算错引退款潮",
    category: "直播电商",
    comments: "6.7k",
    likes: "3.4w",
    heat: "71.8 万热度",
    snippet: "直播间“算错价”闹上热搜，买家和吃瓜群众双双蹲进展，后续一更新就有人搬运。",
  },
  {
    rank: 4,
    tag: "新",
    tagType: "normal",
    title: "萌宠区顶流“橘座”视频爆火，评论区人均铲屎官",
    category: "萌宠日常",
    comments: "4.1k",
    likes: "3.9w",
    heat: "58.6 万热度",
    snippet: "软萌营业谁能顶得住，瓜田需要这样治愈的糖，看完一整天心情都好。",
  },
];

export const boardCategories = [
  { id: "star", icon: "ri-star-smile-line", name: "明星吃瓜", count: "32.6w 帖", desc: "红毯生图、同框图鉴、剧组日常一网打尽" },
  { id: "variety", icon: "ri-tv-2-line", name: "综艺前线", count: "21.4w 帖", desc: "选秀直拍、名场面、花絮考古都在这里" },
  { id: "drama", icon: "ri-film-line", name: "追剧雷达", count: "18.9w 帖", desc: "爆款剧、结局讨论、角色站队聊到深夜" },
  { id: "music", icon: "ri-mic-line", name: "乐坛动态", count: "12.3w 帖", desc: "新歌首发、巡演路透、live 封神现场" },
  { id: "live", icon: "ri-live-line", name: "网红热点", count: "15.7w 帖", desc: "主播翻车、名场面、二创玩梗全收录" },
  { id: "fashion", icon: "ri-shirt-line", name: "穿搭鉴宝", count: "9.8w 帖", desc: "同款扒皮、妆造盘点、红毯品味显微镜" },
  { id: "chat", icon: "ri-chat-3-line", name: "树洞倾诉", count: "28.2w 帖", desc: "想说的话说不出口？深夜树洞收留你" },
  { id: "find", icon: "ri-user-follow-line", name: "找同好", count: "11.5w 帖", desc: "对暗号、找搭子、蹲后续组队追更" },
];

export type TreeHole = {
  id: number;
  emoji: string;
  text: string;
  likes: string;
  time: string;
  replies: string;
};

export const treeHoles: TreeHole[] = [
  { id: 1, emoji: "🌙", text: "追了三年的剧今晚大结局，明知道是圆满却还是舍不得，有人懂这种空落落吗。", likes: "3.2k", time: "12 分钟前", replies: "486" },
  { id: 2, emoji: "🙊", text: "实名羡慕那种能把自己喜欢的剧安利给全宿舍还不被嫌弃的人，我安利一次被骂一次。", likes: "1.8k", time: "38 分钟前", replies: "213" },
  { id: 3, emoji: "🍉", text: "工作一整天的快乐就是下班蹲在瓜田里看路透，谁懂这种不用动脑的快乐。", likes: "4.5k", time: "1 小时前", replies: "702" },
  { id: 4, emoji: "✨", text: "路透图里那个小细节真的嗑到了，虽然知道是营业，但还是想给自己留一点点期待。", likes: "2.6k", time: "2 小时前", replies: "358" },
];

export type Faq = { q: string; a: string };
export const faqs: Faq[] = [
  {
    q: "嗑瓜星球是个什么样的社区？",
    a: "这里是一群爱看热搜、爱追剧、爱刷瓜的年轻人聚集地。你可以实时看热榜、逛话题板块、刷各路网友的犀利热评，也能在树洞里匿名倾诉、在群聊里找同好组队追更，24 小时都有人在线陪你聊。",
  },
  {
    q: "我想发帖或参与讨论，需要怎么做？",
    a: "在话题板块选择你感兴趣的栏目进入即可发帖评论；想匿名说心里话可以进深夜树洞；想找人一起追更就在群聊区发暗号约搭子。所有板块都全天候开放，找到同频的人很简单。",
  },
  {
    q: "社区里的瓜和爆料来源可靠吗？",
    a: "站内内容主要来自网友自发分享与转载讨论，热榜只做聚合展示。我们鼓励理性吃瓜、尊重事实，涉及未经证实的消息会标注讨论性质，不鼓励人身攻击与恶意造谣，希望大家玩得开心也守住底线。",
  },
  {
    q: "树洞真的匿名吗？",
    a: "深夜树洞以匿名形式呈现，内容不会与账号昵称直接关联，你可以放心倾诉不想对熟人说的话。当然，发布内容仍需遵守基本规则，不涉及违法违规与侵犯他人隐私的信息。",
  },
  {
    q: "怎么找到和我兴趣一样的同好？",
    a: "在“找同好”板块晒出你追的剧、听的歌或嗑的 CP，附上暗号就行；也可以在热门帖子的群聊链接里加入对应主题群组，和同频的瓜友一起蹲后续、补档、二创，氛围很轻松。",
  },
];

export const testimonials = [
  { name: "@橘子汽水", avatar: "https://readdy.ai/api/search-image?query=cute%20cartoon%20illustration%20of%20an%20orange%20cat%20avatar%20wearing%20sunglasses%2C%20flat%20vector%20style%2C%20warm%20cream%20background%2C%20soft%20colors%2C%20cheerful%20mood&width=120&height=120&seq=avatar-grape-01&orientation=squarish", role: "追剧达人", text: "每天下班就上来蹲大结局讨论，树洞里还有人懂那种剧终的空落落，真的被治愈到。" },
  { name: "@薯条不加冰", avatar: "https://readdy.ai/api/search-image?query=cute%20cartoon%20illustration%20of%20golden%20french%20fries%20character%20avatar%20with%20happy%20face%2C%20flat%20vector%20style%2C%20cream%20background%2C%20soft%20warm%20tones&width=120&height=120&seq=avatar-fries-02&orientation=squarish", role: "综艺老粉", text: "三公直拍一出全站都在刷，名场面解读帖质量超高，简直是我的追更搭子基地。" },
  { name: "@看瓜不吃瓜", avatar: "https://readdy.ai/api/search-image?query=cute%20cartoon%20illustration%20of%20a%20smiling%20watermelon%20slice%20character%20avatar%2C%20flat%20vector%20style%2C%20cream%20background%2C%20soft%20green%20and%20red%20colors&width=120&height=120&seq=avatar-melon-03&orientation=squarish", role: "吃瓜群众", text: "评论氛围很理性，讲道理的多、带节奏的少，这点真的难得，愿意一直待着。" },
  { name: "@深夜树洞鲸", avatar: "https://readdy.ai/api/search-image?query=cute%20cartoon%20illustration%20of%20a%20small%20whale%20character%20avatar%20floating%20in%20night%20sky%20with%20stars%2C%20flat%20vector%20style%2C%20soft%20mint%20teal%20night%20background%20with%20stars&width=120&height=120&seq=avatar-whale-04&orientation=squarish", role: "树洞常客", text: "深夜想说话的时候打开树洞，哪怕只是碎碎念也有人认真回，这里是第二个精神角落。" },
];